import { render, staticRenderFns } from "./ExtendOtherNutrientsVitaminD.vue?vue&type=template&id=055aa77c&scoped=true"
import script from "./ExtendOtherNutrientsVitaminD.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsVitaminD.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsVitaminD.vue?vue&type=style&index=0&id=055aa77c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055aa77c",
  null
  
)

export default component.exports